import { isObject } from '~/utils/v'
import { SEARCH_KEYS_WHITELIST_API } from '~/utils/search/search.constants'

export class SearchService {
  http = null

  constructor (http) {
    this.http = http
  }

  post (ctx, formData) {
    return ctx.$aProxy.get(`/proxy?proxyUrl=${this.getUrl(formData)}`)
  }

  getUrl (formData) {
    const queryString = this.createQueryString(formData)
    return `/redis-search/&${queryString}`
  }

  createQueryString (obj) {
    return Object.keys(obj)
      .filter(k => SEARCH_KEYS_WHITELIST_API.includes(k))
      .filter(k => Array.isArray(obj[k]) ? !!obj[k].filter(i => i).length : true)
      .filter(k => isObject(obj[k]) ? Object.values(obj[k]).filter(i => i).length : true)
      .map(k => `${k}=${obj[k] !== null ? encodeURIComponent(obj[k]) : ''}`)
      .join('&')
  }

  urlConfig (path) {
    return this.http.post('/api/search/url-config', { path })
  }
}
